"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TOKEN_EXPIRATION_KEY = exports.STATE_KEY = exports.PLATFORM_KEY = exports.LOCATION_ID_KEY = exports.IMPERSONATED_KEY = exports.ID_TOKEN_KEY = exports.DOMAIN_KEY = exports.AUTH_CLIENT_ID_KEY = exports.AUDIENCE_KEY = exports.ACCESS_TOKEN_KEY = void 0;

var _index = _interopRequireDefault(require("auth0-js/src/web-auth/index"));

var _jwtDecode = _interopRequireDefault(require("jwt-decode"));

var _api = _interopRequireDefault(require("./api"));

var _url = require("../utils/url");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ACCESS_TOKEN_KEY = 'access_token';
exports.ACCESS_TOKEN_KEY = ACCESS_TOKEN_KEY;
var ID_TOKEN_KEY = 'id_token';
exports.ID_TOKEN_KEY = ID_TOKEN_KEY;
var STATE_KEY = 'auth0_state';
exports.STATE_KEY = STATE_KEY;
var AUTH_CLIENT_ID_KEY = 'auth_client_id';
exports.AUTH_CLIENT_ID_KEY = AUTH_CLIENT_ID_KEY;
var LOCATION_ID_KEY = 'curb_location_id';
exports.LOCATION_ID_KEY = LOCATION_ID_KEY;
var PLATFORM_KEY = 'platform';
exports.PLATFORM_KEY = PLATFORM_KEY;
var IMPERSONATED_KEY = 'impersonated';
exports.IMPERSONATED_KEY = IMPERSONATED_KEY;
var TOKEN_EXPIRATION_KEY = 'token_expiration';
exports.TOKEN_EXPIRATION_KEY = TOKEN_EXPIRATION_KEY;
var AUDIENCE_KEY = 'auth_audience';
exports.AUDIENCE_KEY = AUDIENCE_KEY;
var DOMAIN_KEY = 'auth_domain';
exports.DOMAIN_KEY = DOMAIN_KEY;

var AuthService = /*#__PURE__*/function () {
  function AuthService() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, AuthService);

    var clientId = params.clientId,
        domain = params.domain,
        audience = params.audience,
        nonce = params.nonce,
        useCordovaAuth = params.useCordovaAuth,
        _params$connection = params.connection,
        connection = _params$connection === void 0 ? 'Users' : _params$connection;
    this.clientId = window.localStorage.getItem(AUTH_CLIENT_ID_KEY) || clientId;
    this.domain = window.localStorage.getItem(DOMAIN_KEY) || domain;
    this.audience = window.localStorage.getItem(AUDIENCE_KEY) || audience;
    this.nonce = nonce;
    this.useCordovaAuth = useCordovaAuth;
    this.connection = connection;
    this.APICall = (0, _api.default)(this);
    this.renewAuth = this.renewAuth.bind(this);
    this.logoutWithReentry = this.logoutWithReentry.bind(this);
    this.logout = this.logout.bind(this);

    if (this.domain && this.clientId) {
      this.update();
      this.maintainAuthSession();
    }
  }

  _createClass(AuthService, [{
    key: "maintainAuthSession",
    value: function maintainAuthSession() {
      var _this = this;

      if (!this.useCordovaAuth) {
        var backgroundRenewAuth = function backgroundRenewAuth() {
          return _this.renewAuth().catch( // this can fail silently
          function (err) {
            return err;
          });
        };

        var expiration = parseInt(window.localStorage.getItem(TOKEN_EXPIRATION_KEY), 10);
        window.addEventListener('beforeunload', function (e) {
          backgroundRenewAuth();
        }); // if we have a token and it will expire in less than 30 minutes, go ahead and renew it

        if (!isNaN(expiration) && expiration - Math.floor(Date.now() / 1000) < 60 * 30) {
          backgroundRenewAuth();
        }
      }
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.useCordovaAuth && this.clientId && this.domain) {
        this.auth0 = new _index.default(this.getAuthParams());
      }
    }
  }, {
    key: "getRedirectURIWithEntry",
    value: function getRedirectURIWithEntry(entry) {
      var redirectUri = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AuthService.callbackURL();
      var url = new URL(redirectUri);
      url.searchParams.set('entry', entry);
      return url.toString();
    }
  }, {
    key: "authorize",
    value: function authorize() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.auth0.authorize(params);
    }
  }, {
    key: "getAuthParams",
    value: function getAuthParams() {
      var params = {
        domain: this.domain,
        clientID: this.clientId,
        audience: this.audience,
        scope: 'openid email profile',
        responseType: 'token',
        redirectUri: AuthService.callbackURL(),
        connection: this.connection
      };
      var state = window.localStorage.getItem(STATE_KEY);

      if (state) {
        params.state = state;
      }

      return params;
    }
  }, {
    key: "isImpersonated",
    value: function isImpersonated() {
      return localStorage.getItem(IMPERSONATED_KEY) === 'true';
    }
  }, {
    key: "processAuthResult",
    value: function processAuthResult(authResult) {
      var access_token = authResult.access_token,
          id_token = authResult.id_token,
          state = authResult.state;
      this.clearStoredAuthValues();

      if (access_token) {
        localStorage.setItem(ACCESS_TOKEN_KEY, access_token); // look for a client id in the token, save it to persistent storage and reupdate

        try {
          var tokenDecoded = (0, _jwtDecode.default)(access_token);
          var azp = tokenDecoded.azp,
              exp = tokenDecoded.exp,
              aud = tokenDecoded.aud,
              iss = tokenDecoded.iss;

          if (azp) {
            this.clientId = azp;
            window.localStorage.setItem(AUTH_CLIENT_ID_KEY, this.clientId);
          }

          if (exp) {
            window.localStorage.setItem(TOKEN_EXPIRATION_KEY, exp);
          }

          if (aud) {
            var audience = Array.isArray(aud) ? aud[0] : aud;
            this.audience = audience;
            window.localStorage.setItem(AUDIENCE_KEY, this.audience);
          }

          if (iss) {
            this.domain = iss.replace(/(^https?:\/\/)|(\/$)/ig, '');
            window.localStorage.setItem(DOMAIN_KEY, this.domain);
          }
        } catch (err) {
          console.error(err);
        }
      }

      if (id_token) {
        localStorage.setItem(ID_TOKEN_KEY, id_token);
      }

      if (state) {
        localStorage.setItem(STATE_KEY, state);
      }

      this.update();
    }
  }, {
    key: "processAuthHash",
    value: function processAuthHash(hash) {
      // uses auth0 parseHash method to extract data from url hash
      if (!hash) {
        throw new Error('Auth hash is required');
      }

      hash = hash.replace(/^#/, '');
      var authResult = (0, _url.parseQueryString)(hash);

      if (authResult) {
        this.processAuthResult(authResult);
      }

      return authResult;
    }
  }, {
    key: "getAuthHash",
    value: function getAuthHash() {
      var tokenKeys = [ACCESS_TOKEN_KEY]; // send an id token if there is one

      if (this.getToken(ID_TOKEN_KEY)) {
        tokenKeys.push(ID_TOKEN_KEY);
      }

      return tokenKeys.reduce(function (a, b, i) {
        return [a, i === 0 ? '?' : '&', b, '=', localStorage.getItem(b)].join('');
      }, '');
    }
  }, {
    key: "renewAuth",
    value: function renewAuth() {
      var _this2 = this;

      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Promise(function (resolve, reject) {
        if (!_this2.loggedIn()) {
          return reject('Can not renew auth - user is not logged in');
        }

        if (_this2.isImpersonated()) {
          return reject('Impersonation session can not renew authentication');
        }

        var state = localStorage.getItem(STATE_KEY);
        var extraParams = state ? {
          state: localStorage.getItem(STATE_KEY),
          nonce: _this2.nonce
        } : {};

        _this2.auth0.checkSession(_objectSpread(_objectSpread({
          timeout: 10000
        }, _this2.getAuthParams()), extraParams), function (err, result) {
          if (err) {
            console.error("Could not get a new token using silent authentication (".concat(err.error, ")."));
            reject(err); // only autoLogout
          } else {
            _this2.processAuthResult({
              access_token: result.accessToken,
              state: result.state
            });

            resolve(result);
          }
        });
      });
    }
  }, {
    key: "loggedIn",
    value: function loggedIn() {
      return !!this.getToken();
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ACCESS_TOKEN_KEY;

      if (token) {
        localStorage.setItem(key, token);
      }
    }
  }, {
    key: "getToken",
    value: function getToken() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ACCESS_TOKEN_KEY;
      var token = localStorage.getItem(key);
      return token && token === 'null' ? null : token;
    }
  }, {
    key: "clearStoredAuthValues",
    value: function clearStoredAuthValues() {
      [ACCESS_TOKEN_KEY, ID_TOKEN_KEY, IMPERSONATED_KEY, LOCATION_ID_KEY, STATE_KEY, AUTH_CLIENT_ID_KEY, TOKEN_EXPIRATION_KEY, AUDIENCE_KEY, DOMAIN_KEY].forEach(function (key) {
        return localStorage.removeItem(key);
      });
    }
  }, {
    key: "logoutWithReentry",
    value: function logoutWithReentry() {
      var entry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _url.getFullPath)();
      return this.logout({
        entry: entry
      });
    }
  }, {
    key: "logout",
    value: function logout() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          entry = _ref.entry,
          _ref$callbackPath = _ref.callbackPath,
          callbackPath = _ref$callbackPath === void 0 ? '/login' : _ref$callbackPath,
          _ref$omitReturnToPara = _ref.omitReturnToParams,
          omitReturnToParams = _ref$omitReturnToPara === void 0 ? false : _ref$omitReturnToPara,
          _ref$returnToParams = _ref.returnToParams,
          returnToParams = _ref$returnToParams === void 0 ? {} : _ref$returnToParams;

      var returnTo = AuthService.callbackURL(callbackPath);

      if (!omitReturnToParams) {
        returnToParams.client_id = this.clientId;
        var redirect_uri_params = {};

        if (entry) {
          redirect_uri_params.entry = encodeURIComponent(entry);
        }

        returnToParams.redirect_uri = (0, _url.addParamsToUrl)(redirect_uri_params, AuthService.callbackURL()).toString();
      }

      ;
      returnTo = "".concat(returnTo).concat((0, _url.toQueryString)(returnToParams));
      this.clearStoredAuthValues(); // window.location = returnTo;

      if (this.auth0) {
        this.auth0.logout({
          clientID: this.clientId,
          returnTo: returnTo
        });
      }
    }
  }], [{
    key: "callbackURL",
    value: function callbackURL() {
      var callbackPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/token';

      if (/^https?:\/\//.test(callbackPath)) {
        return callbackPath;
      } // create url, clear search and hash and set callback path


      var url = new URL(window.location.href);
      url.search = '';
      url.hash = '';
      url.pathname = callbackPath;
      return url.toString();
    }
  }]);

  return AuthService;
}();

exports.default = AuthService;